module.exports = __webpack_public_path__ + "img/alkalmazasok_txt.d273a737.png";